import * as React from 'react';

import { cn } from '@/lib/utils';

// 44 px sur ordinateur, 48 px sur téléphone, texte 16 px : un champ plus petit
// fait zoomer iOS à la saisie, et sa bordure (gris moyen) doit se voir au soleil.
const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        'flex h-12 w-full rounded-md border border-input bg-card px-3.5 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 lg:h-11',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export { Input };
